const features = [
  {
    icon: 'ri-pencil-ruler-2-line',
    title: 'Custom Design Consultation',
    description: 'Work directly with our experts to design unique masonry solutions that perfectly match your vision and project requirements.',
  },
  {
    icon: 'ri-paint-brush-line',
    title: 'Specialty Concrete Finishes',
    description: 'From stamped patterns to exposed aggregate, we create stunning decorative finishes that enhance any space.',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Decorative Masonry Work',
    description: 'Artistic stonework, custom brick patterns, and ornamental concrete elements that add character and value.',
  },
  {
    icon: 'ri-tools-fill',
    title: 'Repair & Restoration Services',
    description: 'Expert restoration of existing masonry structures, preserving historical integrity while ensuring structural soundness.',
  },
  {
    icon: 'ri-road-map-line',
    title: 'Grading Partnerships',
    description: 'Collaborative site preparation and grading services to ensure proper foundation and drainage for your project.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Project Management Support',
    description: 'Comprehensive coordination from planning through completion, ensuring your project stays on schedule and within budget.',
  },
];

const ServiceFeatures = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">
            Comprehensive Custom Services
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Every project is unique. We provide specialized masonry solutions tailored to your specific needs, from initial design to final execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all border-2 border-transparent hover:border-yellow-500"
            >
              <div className="w-16 h-16 bg-yellow-500 rounded-xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-black`}></i>
              </div>

              <h3 className="text-2xl font-bold text-black mb-4">
                {feature.title}
              </h3>

              <p className="text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFeatures;